export const normalizeSessionId = sessionId => {
  if (typeof sessionId !== 'string') return '';

  return sessionId.trim();
};

const getUtf8ByteLength = value => {
  let byteLength = 0;

  for (const character of value) {
    const codePoint = character.codePointAt(0);

    if (codePoint <= 0x7f) byteLength += 1;
    else if (codePoint <= 0x7ff) byteLength += 2;
    else if (codePoint <= 0xffff) byteLength += 3;
    else byteLength += 4;
  }

  return byteLength;
};

export const isValidFirestoreDocumentId = documentId => {
  const normalizedDocumentId = normalizeSessionId(documentId);

  if (!normalizedDocumentId) return false;
  if (normalizedDocumentId.includes('/')) return false;
  if (normalizedDocumentId === '.' || normalizedDocumentId === '..') return false;
  if (/^__.*__$/.test(normalizedDocumentId)) return false;

  return getUtf8ByteLength(normalizedDocumentId) <= 1500;
};

export const normalizeFirestoreDocumentId = documentId => {
  const normalizedDocumentId = normalizeSessionId(documentId);

  return isValidFirestoreDocumentId(normalizedDocumentId)
    ? normalizedDocumentId
    : '';
};

export const getSessionIdFromRoute = ({ pathSessionId, search = '' } = {}) => {
  const normalizedPathSessionId = normalizeFirestoreDocumentId(pathSessionId);

  if (normalizedPathSessionId) return normalizedPathSessionId;

  const searchParams = new URLSearchParams(search);
  return normalizeFirestoreDocumentId(searchParams.get('sessionId') ?? '');
};
